var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDownGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 30
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 22.202L7 30l7-7.798-1.418-1.362-4.615 5.137L7.968 0H6.032l-.001 25.979-4.613-5.139z",
    fill: "#8C8C8C",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDE0IDMwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbD0iIzhDOEM4QyI+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTU2OC4yMDIgNDcyTDU3NiA0NzkgNTY4LjIwMiA0ODYgNTY2Ljg0IDQ4NC41ODIgNTcxLjk3NyA0NzkuOTY3IDU0NiA0NzkuOTY4IDU0NiA0NzguMDMyIDU3MS45NzkgNDc4LjAzMSA1NjYuODQgNDczLjQxOHoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01NzQgLTUyNCkgdHJhbnNsYXRlKDIwIDYwKSBtYXRyaXgoMCAxIDEgMCA4MiAtODIpIi8+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgArrowDownGray as ReactComponent };